import { render, staticRenderFns } from "./MediaCategoryStickersTab.vue?vue&type=template&id=6997da16"
import script from "./MediaCategoryStickersTab.vue?vue&type=script&lang=js"
export * from "./MediaCategoryStickersTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports